module.exports = __webpack_public_path__ + "static/media/all.85c8339d.svg";